import Text from "../context/language-context";

export const useVedOptions = () => {
  const vedMapping: { [key: string]: { label: any; vedashakhas: any[] } } = {
    RIGVEDA: {
      label: Text({ tid: "RIGVEDA", def: "Rigveda" }),
      vedashakhas: [
        Text({ tid: "SHAKHA_SHAKALA", def: "Shakala" }),
        Text({ tid: "SHAKHA_BASHKALA", def: "Bashkala" }),
        Text({ tid: "SHAKHA_SHANKHAYANA", def: "Shankhayana" }),
      ],
    },
    SHUKLA_YAJURVEDA: {
      label: Text({ tid: "SHUKLA_YAJURVEDA", def: "Shukla Yajurveda" }),
      vedashakhas: [
        Text({ tid: "SHAKHA_KANVA", def: "Kanva" }),
        Text({ tid: "SHAKHA_MADHYANDINA", def: "Madhyandina" }),
      ],
    },
    KRISHNA_YAJURVEDA: {
      label: Text({ tid: "KRISHNA_YAJURVEDA", def: "Krishna Yajurveda" }),
      vedashakhas: [
        Text({ tid: "SHAKHA_TAITTIRIYA", def: "Taittiriya" }),
        Text({ tid: "SHAKHA_MAITRAYANI", def: "Maitrayani" }),
      ],
    },
    SAMAVEDA: {
      label: Text({ tid: "SAMAVEDA", def: "Samaveda" }),
      vedashakhas: [
        Text({ tid: "SHAKHA_KAUTHUMA", def: "Kauthuma" }),
        Text({ tid: "SHAKHA_JAIMINIYA", def: "Jaiminiya" }),
        Text({ tid: "SHAKHA_RANAYANIYA", def: "Ranayaniya" }),
      ],
    },
    ATHARVAVEDA: {
      label: Text({ tid: "ATHARVAVEDA", def: "Atharvaveda" }),
      vedashakhas: [
        Text({ tid: "SHAKHA_SHAUNAKA", def: "Shaunaka" }),
        Text({ tid: "SHAKHA_PAIPPALADA", def: "Paippalada" }),
      ],
    },
  };

  return vedMapping;
};
